import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-[#fafafa] pb-[100px] font-[350] font-poppins" }

import Navigation from '@/components/Structure/Navigation.vue'
    import FooterDesktop from '@/components/Structure/Footer.vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

    
return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.$route.meta.hideNavbar)
      ? (_openBlock(), _createBlock(Navigation, {
          key: 0,
          user: "ABC"
        }))
      : _createCommentVNode("", true),
    _createElementVNode("section", _hoisted_1, [
      _createVNode(_component_router_view)
    ]),
    _createVNode(FooterDesktop)
  ], 64))
}
}

})